<template>
  <drag-wrap
    v-if="compVisible"
    :visible="compVisible"
    modalId="quiz-modal"
    modalName="答题器"
  >
    <div class="quiz-container">
      <!-- 标题栏 -->
      <div class="quiz-header">
        <div class="title">答题器</div>
        <div class="close" @click="handleClose()" v-if="!isStudent">
          <img src="@saas/pages/assets/images/live/close-1.png" alt="" />
        </div>
      </div>

      <!-- 内容区域 -->
      <div class="quiz-content">
        <!-- 选择题型页面 -->
        <div v-if="currentPage === 'selectType'" class="select-type-page">
          <div class="type-options">
            <div
              v-for="type in questionTypes"
              :key="type.value"
              class="type-option"
              :class="{ active: selectedType === type.value }"
              @click="handleSelectType(type.value)"
            >
              {{ type.label }}
            </div>
          </div>
        </div>

        <!-- 设置选项页面 -->
        <div v-if="currentPage === 'setOptions'" class="set-options-page">
          <div class="options-container">
            <div
              class="option-row"
              :class="{ multiple: currentOptions.length > 4 }"
            >
              <!-- 左侧题号 -->
              <div class="question-number">
                <div class="number-input">
                  <span>1</span>
                </div>
              </div>

              <!-- 中间选项 -->
              <div class="options-section">
                <div class="options-row">
                  <div
                    v-for="option in currentOptions"
                    :key="option"
                    class="option-item"
                    :class="{ selected: selectedAnswers.includes(option) }"
                    @click="handleToggleOption(option)"
                  >
                    {{ option }}
                  </div>
                </div>
              </div>

              <!-- 右侧增减按钮 -->
              <div
                class="options-controls"
                v-if="
                  !(
                    ['setOptions', 'judgeOptions'].includes(currentPage) &&
                    showSetAnswer
                  )
                "
              >
                <div class="add-option" @click="handleAddOption">
                  <!-- <i class="el-icon-plus"></i> -->
                  <img
                    class="el-icon-plus"
                    width="20px"
                    src="@saas/pages/assets/images/live/add.png"
                    alt=""
                  />
                </div>
                <div class="remove-option" @click="handleRemoveOption">
                  <!-- <i class="el-icon-minus"></i> -->
                  <img
                    class="el-icon-minus"
                    width="20px"
                    src="@saas/pages/assets/images/live/minus.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 判断题选项设置页面 -->
        <div v-if="currentPage === 'judgeOptions'" class="judge-options-page">
          <div class="question-number" v-if="false">
            <div class="number-input">
              <span>1</span>
            </div>
          </div>

          <div v-if="id === 0" class="judge-options-container">
            <div
              v-for="(group, groupIndex) in judgeOptionGroups"
              :key="groupIndex"
              class="judge-option-group"
            >
              <div class="group-row">
                <!-- 左侧单选按钮 -->
                <div
                  class="radio-indicator"
                  @click="handleSelectJudgeOption(groupIndex, true)"
                >
                  <div
                    class="radio-button"
                    :class="{ selected: selectedJudgeAnswers[groupIndex] }"
                  ></div>
                </div>

                <!-- 右侧选项按钮 -->
                <div class="group-options">
                  <div
                    v-for="option in group.options"
                    :key="option.value"
                    class="judge-option-item"
                    :class="{
                      selected:
                        selectedJudgeAnswers[groupIndex] === option.value,
                    }"
                    @click.prevent="
                      handleSelectJudgeOption(groupIndex, option.value)
                    "
                  >
                    {{ option.label }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="judge-options-container">
            <div class="judge-option-group">
              <!-- 右侧选项按钮 -->
              <div class="group-options">
                <div
                  v-for="option in currentOptions"
                  :key="option"
                  class="judge-option-item"
                  :class="{
                    selected: selectedAnswers[0] === option,
                  }"
                  @click="handleSelectJudgeOption(-1, option)"
                >
                  {{ option }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 填空题选项设置页面 -->
        <!-- <div v-if="currentPage === 'fillOptions'" class="set-options-page">
          <div class="options-container">
            <div class="option-row">
              <div class="question-number">
                <div class="number-input">
                  <span>1</span>
                </div>
              </div>
              <div class="options-section">
                <el-input
                  type="text"
                  class="fill-input"
                  placeholder="请输入答案"
                  v-model="fillAnswer"
                  maxlength="10"
                  show-word-limit
                />
              </div>
            </div>
          </div>
        </div> -->

        <!-- 答题结果页面 -->
        <div v-if="currentPage === 'result'" class="result-page">
          <!-- 统计信息 -->
          <div class="stats-container">
            <div class="stat-item">
              <div class="stat-value">
                <span class="time">{{ displayTimeMin(totalTime)[0] }}</span>
                <div class="dots">
                  <div class="dot"></div>
                  <div class="dot"></div>
                </div>
                <span class="time">{{ displayTimeMin(totalTime)[1] }}</span>
              </div>
              <div class="stat-label">总用时</div>
            </div>

            <div class="stat-item">
              <div class="stat-value">
                <span class="count">{{ answerCount }}/</span>
                <span class="total">{{ totalStudent }}</span>
                <span class="unit">人</span>
              </div>
              <div class="stat-label">已回答</div>
            </div>

            <div class="stat-item">
              <div class="stat-value" v-if="hasSetAnswer">
                <span class="rate">{{
                  answerCount
                    ? ((rightAnswerCount / answerCount) * 100).toFixed(0)
                    : 0
                }}</span>
                <span class="percent">%</span>
              </div>
              <div class="stat-value" v-else>
                <span class="percent">一一</span>
              </div>
              <div class="stat-label">正确率</div>
            </div>
          </div>

          <!-- Tab切换 -->
          <div class="tab-container">
            <div class="tab-buttons">
              <div
                class="tab-button"
                :class="{ active: activeTab === 'stats' }"
                @click="handleTabChange('stats')"
              >
                统计
              </div>
              <div
                class="tab-button"
                :class="{ active: activeTab === 'details' }"
                @click="handleTabChange('details')"
              >
                明细
              </div>
            </div>
          </div>

          <!-- 统计内容 -->
          <div v-if="activeTab === 'stats'" class="stats-content">
            <div
              v-for="option in optionStats"
              :key="option.key"
              class="option-stat"
            >
              <div class="option-info">
                <span class="option-label">
                  {{ option.sub_option }}
                  {{
                    answerCount
                      ? ((option.count / answerCount) * 100).toFixed(0)
                      : 0
                  }}%
                  <img
                    class="right-icon"
                    v-if="option.is_right"
                    src="@saas/pages/assets/images/live/is-right.png"
                    alt=""
                  />
                </span>
                <el-popover
                  placement="top"
                  width="148"
                  trigger="click"
                  v-if="option.count > 0"
                  popper-class="option-detail-popover"
                >
                  <div class="option-detail">
                    <div class="option-detail-header option-detail-item">
                      <span class="nickname">昵称</span>
                      <span class="time">用时</span>
                    </div>
                    <div class="option-detail-item-wrap">
                      <div
                        v-for="item in answerDetails.filter(
                          (item) => item.sub_option === option.sub_option
                        )"
                        :key="item.id"
                        class="option-detail-item"
                      >
                        <span class="nickname">{{ item.nickname }}</span>
                        <span class="time">{{
                          displayTimeMin(item.answer_time)[0] +
                          ":" +
                          displayTimeMin(item.answer_time)[1]
                        }}</span>
                      </div>
                    </div>
                  </div>
                  <span class="option-count" slot="reference">
                    {{ option.count }} 人
                    <i v-if="option.count > 0" class="el-icon-arrow-right"></i>
                  </span>
                </el-popover>
                <span class="option-count" slot="reference" v-else>
                  {{ option.count }} 人
                </span>
              </div>
              <div class="progress-bar">
                <div class="progress-bg"></div>
                <div
                  class="progress-fill"
                  :style="{
                    width: answerCount
                      ? ((option.count / answerCount) * 100).toFixed(0) + '%'
                      : '0%',
                  }"
                ></div>
              </div>
            </div>
          </div>

          <!-- 明细内容 -->
          <div v-if="activeTab === 'details'" class="details-content">
            <div class="details-header">
              <span class="header-item">昵称</span>
              <span class="header-item">所选答案</span>
              <span class="header-item">用时</span>
            </div>
            <div class="details-list">
              <div
                v-for="(detail, index) in answerDetails"
                :key="index"
                class="detail-item"
              >
                <span class="detail-nickname">{{ detail.nickname }}</span>
                <span class="detail-answer">{{ detail.sub_option }}</span>
                <span class="detail-time">{{
                  displayTimeMin(detail.answer_time)[0] +
                  ":" +
                  displayTimeMin(detail.answer_time)[1]
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 底部按钮 -->
      <div class="quiz-footer">
        <template v-if="currentPage === 'selectType'">
          <!-- 选择题型页面没有底部按钮 -->
        </template>

        <template
          v-else-if="
            ['setOptions', 'judgeOptions'].includes(currentPage) &&
            !showSetAnswer
          "
        >
          <el-button type="default" class="action-btn" @click="handleBack">
            上一步
          </el-button>
          <el-button type="primary" class="action-btn" @click="handleStartQuiz">
            开始作答
          </el-button>
        </template>
        <template
          v-else-if="
            ['setOptions', 'judgeOptions'].includes(currentPage) &&
            showSetAnswer
          "
        >
          <el-button
            type="default"
            class="action-btn"
            @click="cancelModifyAnswer"
          >
            取消
          </el-button>
          <el-button
            type="primary"
            class="action-btn"
            :class="{
              'is-disabled btn-highlight': !selectedAnswers.length,
            }"
            @click="handleModifyAnswer"
          >
            保存
          </el-button>
        </template>

        <template v-else-if="currentPage === 'result'">
          <el-button
            v-if="!hasSetAnswer && !isQuizEnded"
            type="primary"
            class="action-btn"
            @click="handleSetAnswer"
          >
            设置答案
          </el-button>
          <el-button
            v-if="hasSetAnswer && !isQuizEnded"
            type="primary"
            class="action-btn"
            @click="handleSetAnswer"
          >
            修改答案
          </el-button>
          <el-button
            v-if="!isQuizEnded"
            type="default"
            class="action-btn end-btn"
            @click="handleEndQuiz(false)"
          >
            结束答题
          </el-button>
          <el-button
            v-if="isQuizEnded"
            type="default"
            class="action-btn"
            @click="handleClose"
          >
            关闭
          </el-button>
          <el-button
            v-if="isQuizEnded"
            type="primary"
            class="action-btn"
            @click="handleNewQuiz"
          >
            新建答题
          </el-button>
        </template>
      </div>
    </div>
  </drag-wrap>
</template>

<script>
import AccurateTimer from "./accurateTimer";
import { mapMutations, mapState } from "vuex";
import { DragWrap } from "@saas/components";
import {
  createAnswer,
  endAnswer,
  setCorrectAnswer,
  getAnswerStats,
  getToolbox,
} from "@saas/server-api/src/live-sdk";
import ScreenShare from "../mixins/screen-share";
import { EventBus } from "@saas/components/src/utils/event-bus";
export default {
  mixins: [ScreenShare],
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    toolboxStatus: {
      type: Object,
      default: () => ({
        allOption: [],
        endTime: 0,
        id: 0,
        questionType: 0,
        rightOption: [],
        roomId: 0,
        version: 0,
      }),
    },
  },
  components: {
    DragWrap,
  },
  data() {
    return {
      id: 0,
      compVisible: false,
      // 当前页面
      currentPage: "selectType", // selectType, setOptions, judgeOptions, result
      // 选中的题型
      selectedType: 0,
      // 当前选项
      currentOptions: ["A", "B", "C", "D"],
      // 选中的答案
      selectedAnswers: [],
      // 判断题选项组
      judgeOptionGroups: [
        {
          title: "第一组",
          options: [
            { label: "可以", value: "可以" },
            { label: "不可以", value: "不可以" },
          ],
        },
        {
          title: "第二组",
          options: [
            { label: "明白", value: "明白" },
            { label: "不明白", value: "不明白" },
          ],
        },
        {
          title: "第三组",
          options: [
            { label: "能", value: "能" },
            { label: "不能", value: "不能" },
          ],
        },
        {
          title: "第四组",
          options: [
            { label: "对", value: "对" },
            { label: "错", value: "错" },
          ],
        },
      ],
      // 选中的判断题答案
      selectedJudgeAnswers: {
        0: true,
      },
      // 活跃的tab
      activeTab: "stats",
      // 是否设置了答案
      hasSetAnswer: false,
      // 是否结束答题
      isQuizEnded: false,
      // 是否为学生
      isStudent: false,
      // 题型列表
      questionTypes: [
        { label: "单选题", value: 1 },
        { label: "多选题", value: 2 },
        { label: "判断题", value: 3 },
        // { label: "填空题", value: 4 },
      ],
      // 选项统计
      optionStats: [],
      // 答题明细
      answerDetails: [],
      showSetAnswer: false,
      answerCount: 0,
      rightAnswerCount: 0,
      totalTime: [],
      totalStudent: 0,
      // 计时器
      timer: null,
      rightOption: [],
      selectedTypeKey: "lastSelectedType",
      // 同步定时器ID
      syncTimerId: null,
      // 上次同步时间
      lastSyncTime: 0,
      fillAnswer: "",
    };
  },
  watch: {
    visible(newVal) {
      this.compVisible = newVal;
      console.log("visible", newVal);
      if (newVal) {
        this.initQuiz();
      }
    },
    toolboxStatus: {
      handler(newStatus) {
        if (newStatus && this.compVisible) {
          const newData = JSON.parse(JSON.stringify(newStatus));
          this.id = newData.id;
          this.selectedType = newData.questionType;
          this.currentOptions = newData.allOption;
          this.selectedAnswers = newData.rightOption || [];
          this.hasSetAnswer = this.selectedAnswers.length > 0;
          this.currentPage = "result";
          this.startTimer(
            Math.floor(newData.serverTime / 1000 - newData.createdAt)
          );
          this.updateStats();
          this.rightOption = JSON.parse(JSON.stringify(this.selectedAnswers));
        }
      },
      deep: true,
      immediate: true,
    },
    imService: {
      handler(val, oldVal) {
        if (val && !oldVal) {
          this.handleImListener();
        }
      },
      immediate: true,
    },
    // allMemberStatus: {
    //   handler(newVal) {
    //     if (newVal) {
    //       if (this.currentPage !== "result") {
    //         this.updateStats();
    //       }
    //     }
    //   },
    //   immediate: true,
    //   deep: true,
    // },
  },
  created() {
    EventBus.$on("updateNickname", this.handleImUpdateNickname);
  },
  beforeDestroy() {
    EventBus.$off("updateNickname", this.handleImUpdateNickname);
  },
  methods: {
    ...mapMutations("live", ["setShowToolbox"]),
    // 初始化答题器
    initQuiz() {
      this.id = 0;
      this.currentPage = "selectType";
      this.selectedType = "";
      this.selectedAnswers = [];
      this.activeTab = "stats";
      this.hasSetAnswer = false;
      this.isQuizEnded = false;
      this.showSetAnswer = false;
      this.currentOptions = ["A", "B", "C", "D"];
      console.log("initQuiz", this.toolboxStatus);
      const storedValue = localStorage.getItem(this.selectedTypeKey);
      this.selectedType = storedValue ? Number(storedValue) : "";
      this.selectedJudgeAnswers = {
        0: true,
      };
    },

    // startQuiz
    startQuiz(question, serverTime) {
      console.log("startQuiz", question, serverTime);
      this.selectedType = question.question_type;
      this.currentOptions = question.all_option;
      this.selectedAnswers = question.right_option || [];
      this.hasSetAnswer = this.selectedAnswers.length > 0;
      this.startTimer(Math.floor(serverTime / 1000 - question.created_at));
      this.isQuizEnded = false;
      this.currentPage = "result";
      this.compVisible = true;
      this.rightOption = JSON.parse(JSON.stringify(this.selectedAnswers));
    },

    // 关闭答题器
    handleClose() {
      if (this.id > 0) {
        this.handleEndQuiz(true);
        return;
      }
      this.compVisible = false;
      this.setShowToolbox({
        answerer: false,
      });
      this.id = 0;
      this.clearTimer();
    },

    // 选择题型
    handleSelectType(type) {
      this.selectedType = type;
      if (type === 1 || type === 2) {
        this.currentPage = "setOptions";
      } else if (type === 3) {
        // 判断题进入判断题选项设置页面
        this.currentPage = "judgeOptions";
      } else if (type === 4) {
        // 填空题
        this.currentPage = "fillOptions";
      }
    },

    // 选择判断题选项
    handleSelectJudgeOption(groupIndex, value) {
      console.log("handleSelectJudgeOption", groupIndex, value);
      if (groupIndex !== -1) {
        this.hasSetAnswer = true;
        this.selectedJudgeAnswers = {};
        this.$set(this.selectedAnswers, 0, value);
        this.$set(this.selectedJudgeAnswers, groupIndex, value);
      } else {
        this.$set(this.selectedAnswers, 0, value);
      }
    },

    // 切换选项
    handleToggleOption(optionKey) {
      if (this.selectedType === 1) {
        // 单选题只能选择一个
        this.selectedAnswers = [optionKey];
      } else if (this.selectedType === 2) {
        // 多选题可以多选
        const index = this.selectedAnswers.indexOf(optionKey);
        if (index > -1) {
          this.selectedAnswers.splice(index, 1);
        } else {
          this.selectedAnswers.push(optionKey);
        }
      }
    },

    // 添加选项
    handleAddOption() {
      if (this.currentOptions.length < 8) {
        const nextKey = String.fromCharCode(65 + this.currentOptions.length); // A, B, C, D, E, F, G, H
        this.currentOptions.push(nextKey);
      }
    },

    // 移除选项
    handleRemoveOption() {
      if (this.currentOptions.length > 2) {
        this.currentOptions.pop();
        // 移除对应的选中答案
        const lastOption = this.currentOptions[this.currentOptions.length - 1];
        this.selectedAnswers = this.selectedAnswers.filter((answer) =>
          this.currentOptions.some((option) => option === answer)
        );
      }
    },

    // 返回上一步
    handleBack() {
      this.currentPage = "selectType";
    },

    // 开始作答
    async handleStartQuiz() {
      try {
        const params = {
          room_id: this.roomInfo.id,
          question_type: this.selectedType,
          all_option: this.currentOptions,
          right_option: this.selectedAnswers,
        };
        if (this.selectedType === 3) {
          Object.keys(this.selectedJudgeAnswers).forEach((key, value) => {
            const rightOption = this.selectedJudgeAnswers[key];
            params.right_option = rightOption === true ? [] : [rightOption];
            params.all_option = this.judgeOptionGroups[key].options.map(
              (item) => item.label
            );
          });
        }
        console.log("params", params);
        console.log("selectedJudgeAnswers", this.selectedJudgeAnswers);
        const res = await createAnswer(params);
        if (res.code === 1) {
          this.id = res.data.id;
          this.currentOptions = res.data.all_option;
          // 发送答题开始通知给学生端
          this.broadcastAnswerEvent("start", {
            id: res.data.id,
            roomId: res.data.room_id,
            createdAt: res.data.created_at,
            allOption: res.data.all_option,
            serverTime: res.serverTime,
            questionType: res.data.question_type,
          });
          this.startTimer(0);
          this.updateStats();
          this.currentPage = "result";
          this.selectedAnswers = res.data.right_option || [];
          this.rightOption = JSON.parse(JSON.stringify(this.selectedAnswers));
          this.hasSetAnswer = !!this.selectedAnswers.length;
          localStorage.setItem(this.selectedTypeKey, this.selectedType);
        } else {
          if (res.code === 1007) {
            const response = await getToolbox({
              room_id: this.roomInfo.id,
            });
            console.log("has response__", response);
            if (response.code === 1) {
              this.startQuiz(response.data.question, response.serverTime);
            } else {
              this.$darkMessage.error(response.message);
            }
          } else {
            this.$darkMessage.error(res.message);
          }
        }
      } catch (error) {
        console.error("创建答题器失败:", error);
        this.$darkMessage.error("创建答题器失败");
      }
    },

    // 处理IM消息监听
    handleImListener() {
      if (this.imService) {
        this.imService.on(
          "recvMGLiveRoomCustomMsg",
          this.handleLiveRoomCustomMsg
        );
      }
    },

    // 处理直播间自定义消息
    handleLiveRoomCustomMsg(res) {
      if (res.data && res.data.type === "question") {
        this.handleImMessage(res.data.data);
      } else if (res.data && res.data.type === "updateNickname") {
        this.handleImUpdateNickname();
      }
    },
    // 处理IM消息
    handleImMessage(data) {
      console.log("Answer收到IM消息:", data, this);

      switch (data?.event) {
        case "submit":
          // 学生提交答案
          this.updateStats();
          break;
        case "start":
          // 老师或助教开始答案器
          this.id = data.id;
          this.updateStats(true);
          break;
        case "updateAnswer":
          // 老师或助教修改答案
          this.selectedAnswers = data.selectedAnswers;
          this.hasSetAnswer = this.selectedAnswers.length > 0;
          this.rightOption = JSON.parse(JSON.stringify(data.selectedAnswers));
          this.updateStats();
          break;
        case "end":
          // 老师或助教结束答案器
          this.id = 0;
          this.clearTimer();
          this.isQuizEnded = true;
          break;
      }
    },

    // 处理IM更新昵称消息
    handleImUpdateNickname() {
      this.updateStats();
    },

    // 更新统计信息
    async updateStats(flag = false) {
      if (!this.id) return;
      if (this.loading) return;
      this.loading = true;
      const res = await getAnswerStats({
        id: this.id,
      });
      if (res.code === 1) {
        const question = res.data.question;
        if (flag) {
          this.startQuiz(question, res.serverTime);
        }

        this.optionStats = this.handleOptionStats(
          res.data.statistics,
          res.data.detail
        );
        this.answerCount = res.data.answer_count;
        this.rightAnswerCount = res.data.right_answer_count;
        this.totalStudent = res.data.total_student;
        this.answerDetails = res.data.detail;
        this.loading = false;
      } else {
        this.loading = false;
        this.$darkMessage.error(res.message);
      }
    },

    handleOptionStats(list) {
      let temp = [];
      if (this.selectedType !== 2) {
        this.currentOptions.forEach((item) => {
          temp.push({
            sub_option: item,
            count: 0,
            is_right: this.selectedAnswers.includes(item),
          });
        });
      } else {
        temp = list;
      }

      list.forEach((item) => {
        temp.forEach((tempItem) => {
          if (tempItem.sub_option === item.sub_option) {
            tempItem.count = item.count;
            tempItem.is_right = item.is_right === 1;
          }
        });
      });
      return temp;
    },

    // 切换Tab
    handleTabChange(tab) {
      this.activeTab = tab;
    },

    // 设置答案
    handleSetAnswer() {
      this.showSetAnswer = true;
      if (this.selectedType === 3) {
        this.currentPage = "judgeOptions";
      } else {
        this.currentPage = "setOptions";
      }
    },

    cancelModifyAnswer() {
      this.currentPage = "result";
      this.selectedAnswers = JSON.parse(JSON.stringify(this.rightOption));
    },

    // 修改答案
    async handleModifyAnswer() {
      if (
        ["setOptions", "judgeOptions"].includes(this.currentPage) &&
        this.showSetAnswer &&
        !this.selectedAnswers.length
      ) {
        return;
      }
      const params = {
        id: this.id,
        right_option: this.selectedAnswers,
      };
      const res = await setCorrectAnswer(params);
      if (res.code === 1) {
        // 发送到老师、助教
        this.broadcastAnswerEvent("updateAnswer", {
          id: res.data.id,
          roomId: res.data.room_id,
          selectedAnswers: res.data.right_option,
        });
        this.rightOption = JSON.parse(JSON.stringify(this.selectedAnswers));
        this.showSetAnswer = false;
        this.hasSetAnswer = true;
        this.currentPage = "result";
        this.updateStats();
      } else {
        this.$darkMessage.error(res.message);
      }
    },

    // 结束答题
    async handleEndQuiz(flag = false) {
      this.$confirm("学生正在答题，确定要结束答题吗？", "", {
        confirmButtonText: "结束答题",
        cancelButtonText: "取消",
        type: "danger",
        showClose: false,
        iconClass: "el-icon-warning",
        customClass: "end-quiz-confirm",
      }).then(async () => {
        if (!this.id) {
          return;
        }
        const res = await endAnswer({
          id: this.id,
        });
        if (res.code === 1) {
          // 发送答题结束通知给学生端
          this.broadcastAnswerEvent("end", {
            id: this.id,
            roomId: res.data.room_id,
            endTime: res.data.end_time,
            rightOption: res.data.right_option,
          });

          this.id = 0;
          this.clearTimer();
          this.isQuizEnded = true;
          this.showSetAnswer = false;
        } else {
          this.$darkMessage.error(res.message);
        }
      });
    },

    // 新建答题
    handleNewQuiz() {
      this.initQuiz();
    },

    // 发送答题通知给学生端
    broadcastAnswerEvent(event, data) {
      if (this.imService) {
        this.imService.sendMGLiveRoomCustomMsg({
          cmdId: 2,
          data: {
            type: "question",
            data: {
              event: event,
              ...data,
            },
          },
        });
      }
    },
    displayTimeMin(time) {
      const totalTime = [Math.floor(time / 60), time % 60];
      return [
        totalTime[0] < 10 ? "0" + totalTime[0] : totalTime[0],
        totalTime[1] < 10 ? "0" + totalTime[1] : totalTime[1],
      ];
    },

    // 启动同步定时器
    startSyncTimer() {
      // 清除之前的同步定时器
      this.clearSyncTimer();

      // 记录开始同步的时间
      this.lastSyncTime = Date.now();

      // 每分钟同步一次时间
      this.syncTimerId = setInterval(() => {
        this.syncTimerTime();
      }, 60000); // 60秒 = 1分钟
    },

    // 清理同步定时器
    clearSyncTimer() {
      if (this.syncTimerId) {
        clearInterval(this.syncTimerId);
        this.syncTimerId = null;
      }
    },

    // 同步定时器时间
    async syncTimerTime() {
      if (!this.visible || !this.id || !this.roomInfo.id) {
        return;
      }

      try {
        // 使用getToolbox接口查询当前状态，而不是pauseTimer
        const response = await getToolbox({
          room_id: this.roomInfo.id,
        });

        if (response.code === 1 && response.data) {
          // 查找当前计时器的状态
          const question = response.data.question;

          if (question) {
            this.clearTimer();
            this.startTimer(
              Math.floor(response.serverTime / 1000 - question.created_at)
            );
          } else {
            console.log("未找到对应的计时器数据");
          }
        } else {
          console.error("获取工具箱状态失败:", response.message);
        }
      } catch (error) {
        console.error("同步定时器时间失败:", error);
      }
    },

    // 开始计时
    startTimer(startTime = 0) {
      if (this.timer) return;
      this.totalTime = startTime;
      // this.timer = setInterval(() => {
      //   this.totalTime++;
      // }, 1000);
      // 初始化计时器，传入Vue实例，实现自动清理
      this.timer = new AccurateTimer(
        () => {
          this.totalTime++;
        }, // 回调函数
        1000, // 时间间隔
        {
          immediate: false,
          vueInstance: this, // 传入当前组件实例
        }
      );

      // 启动计时器
      this.timer.start();

      // 启动同步定时器
      this.startSyncTimer();
    },
    // 清除计时器
    clearTimer() {
      if (this.timer) {
        // clearInterval(this.timer);
        this.timer.stop();
        this.timer = null;
      }
    },
  },
  computed: {
    ...mapState("live", [
      "liveService",
      "imService",
      "whiteBoardService",
      "roomInfo",
      "allMemberStatus",
    ]),
    userInfo() {
      return this.$store.getters.user || {};
    },
  },
};
</script>

<style lang="scss" scoped>
.quiz-container {
  width: 400px;
  height: 508px;
  background: #18181b;
  border: 2px solid #27272a;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  // 自定义滚动条样式
  ::-webkit-scrollbar {
    width: 4px;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background: #252527;
    border-radius: 2px;

    &:hover {
      background: #252527;
    }
  }

  ::-webkit-scrollbar-corner {
    background: transparent;
  }
}

.quiz-header {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px;
  position: relative;
  border-bottom: 1px solid #27272a;

  .title {
    font-family: PingFang SC;
    font-weight: 600;
    font-size: 16px;
    line-height: 1.4;
    color: #ffffff;
    text-align: center;
  }

  .close {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 24px;
      height: 24px;
    }
  }
}

.quiz-content {
  flex: 1;
  padding: 12px;
  overflow-y: auto;
}

// 选择题型页面
.select-type-page {
  margin-top: 50px;
  padding: 0 24px;

  .type-options {
    display: flex;
    flex-direction: column;
    gap: 32px;
  }

  .type-option {
    height: 40px;
    background: #28282c;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: Inter;
    font-weight: 500;
    font-size: 14px;
    color: #ffffff;
    cursor: pointer;
    transition: all 0.3s;

    &:hover {
      background: #303031;
    }

    &.active {
      background: #165dff;
    }
  }
}

// 设置选项页面
.set-options-page {
  padding: 12px;
  background: #1e1e20;
  border-radius: 12px 12px 12px 12px;
  .options-container {
    .option-row {
      display: flex;
      align-items: center;
      gap: 16px;
      &.multiple {
        .options-controls {
          gap: 26px;
        }
        .question-number {
          align-self: flex-start;
        }
      }
    }

    .question-number {
      .number-input {
        width: 40px;
        height: 40px;
        background: #1e1e20;
        border: 1px solid #27272a;
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: Inter;
        font-weight: 500;
        font-size: 14px;
        color: #86909c;
      }
    }

    .options-section {
      flex: 1;

      .options-row {
        display: flex;
        gap: 16px;
        flex-wrap: wrap;
      }

      .option-item {
        width: 40px;
        height: 40px;
        background: #303031;
        box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
        border-radius: 12px 12px 12px 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: Inter;
        font-weight: 500;
        font-size: 14px;
        color: #ffffff;
        cursor: pointer;
        transition: all 0.3s;

        &:hover {
          background: #303031;
        }

        &.selected {
          background: #165dff;
        }
      }
    }

    .options-controls {
      display: flex;
      flex-direction: column;

      .add-option,
      .remove-option {
        width: 32px;
        height: 32px;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        color: #86909c;
        transition: all 0.3s;

        &:hover {
          background: #27272a;
        }

        i {
          font-size: 14px;
        }
      }
    }
  }
}

// 判断题选项设置页面
.judge-options-page {
  .question-number {
    margin-bottom: 24px;

    .number-input {
      width: 40px;
      height: 40px;
      background: #1e1e20;
      border: 1px solid #27272a;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: Inter;
      font-weight: 500;
      font-size: 14px;
      color: #86909c;
    }
  }

  .judge-options-container {
    .judge-option-group {
      margin-bottom: 12px;
      padding: 12px;
      background: #1e1e20;
      border-radius: 12px 12px 12px 12px;

      .group-row {
        display: flex;
        align-items: center;
        gap: 10px 16px;
      }

      .radio-indicator {
        width: 24px;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 4px;

        .radio-button {
          width: 16px;
          height: 16px;
          background: transparent;
          border-radius: 50%;
          border: 2px solid #86909c;
          transition: all 0.3s;
          position: relative;

          &.selected {
            background: #165dff;
            border-color: #165dff;

            &::after {
              content: "";
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: 6px;
              height: 6px;
              background: #ffffff;
              border-radius: 50%;
            }
          }
        }
      }

      .group-options {
        display: flex;
        gap: 12px;
        flex: 1;

        .judge-option-item {
          flex: 1;
          height: 40px;
          background: #27272a;
          border: 1px solid #27272a;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-family: Inter;
          font-weight: 500;
          font-size: 14px;
          color: #ffffff;
          cursor: pointer;
          transition: all 0.3s;

          &:hover {
            background: #303031;
            border-color: #3f3f46;
          }

          &.selected {
            background: #165dff;
            border-color: #165dff;
            color: #ffffff;
          }
        }
      }
    }
  }
}

// 答题结果页面
.result-page {
  padding: 0 12px;
  .stats-container {
    background: rgba(37, 37, 39, 0.2);
    border-radius: 12px;
    padding: 12px;
    margin-bottom: 12px;
    display: flex;
    justify-content: space-between;

    .stat-item {
      text-align: left;

      .stat-value {
        display: flex;
        align-items: center;
        gap: 4px;

        .time {
          font-family: DIN Alternate;
          font-weight: 700;
          font-size: 32px;
          color: #ffffff;
        }

        .dots {
          display: flex;
          flex-direction: column;
          gap: 2px;

          .dot {
            width: 4px;
            height: 4px;
            background: #ffffff;
            border-radius: 50%;
          }
        }

        .count {
          font-family: DIN Alternate;
          font-weight: 700;
          font-size: 32px;
          color: #ffffff;
        }

        .total {
          font-family: DIN Alternate;
          font-weight: 700;
          font-size: 20px;
          color: #ffffff;
        }

        .unit {
          font-family: PingFang SC;
          font-weight: 600;
          font-size: 12px;
          color: #ffffff;
        }

        .rate {
          font-family: DIN Alternate;
          font-weight: 700;
          font-size: 32px;
          color: #ffffff;
        }

        .percent {
          font-family: DIN Alternate;
          font-weight: 700;
          font-size: 20px;
          color: #ffffff;
          height: 48px;
          display: flex;
          align-items: center;
        }
      }

      .stat-label {
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #86909c;
      }
    }
  }

  .tab-container {
    display: flex;
    justify-content: center;
    margin-bottom: 16px;

    .tab-buttons {
      display: flex;
      background: #27272a;
      border-radius: 12px;
      padding: 4px;
    }

    .tab-button {
      padding: 6px 12px;
      border-radius: 8px;
      font-family: PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #86909c;
      cursor: pointer;
      transition: all 0.3s;

      &.active {
        background: #3f3f46;
        color: #ffffff;
        font-weight: 600;
      }
    }
  }

  .stats-content {
    height: 214px;
  }

  .stats-content,
  .details-list {
    overflow-y: auto;

    .option-stat {
      margin-bottom: 12px;

      &:last-child {
        margin-bottom: 0;
      }

      .option-info {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 8px;

        .option-label {
          font-family: PingFang SC;
          font-weight: 600;
          font-size: 16px;
          color: #ffffff;
          display: flex;
          align-items: center;
          .right-icon {
            width: 17px;
            height: 17px;
            margin-left: 8px;
          }
        }

        .option-count {
          font-family: PingFang SC;
          font-weight: 400;
          font-size: 16px;
          color: #ffffff;
        }
      }

      .progress-bar {
        position: relative;
        height: 8px;
        background: #252527;
        border-radius: 12px;
        overflow: hidden;

        .progress-fill {
          width: 0%;
          height: 100%;
          background: #072ca6;
          border-radius: 12px;
          transition: width 0.3s;
        }
      }
    }
  }

  .details-content {
    .details-header {
      display: flex;
      justify-content: space-between;
      margin-bottom: 8px;
      padding: 0 8px;

      .header-item {
        font-family: Inter;
        font-weight: 400;
        font-size: 14px;
        color: #86909c;
        flex: 1;
        text-align: center;

        &:first-child {
          text-align: left;
        }

        &:last-child {
          text-align: right;
        }
      }
    }

    .details-list {
      height: 184px;
      .detail-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px;
        background: #1b1b1d;
        border-radius: 12px;

        &:nth-child(even) {
          background: #1b1b1d;
        }

        .detail-nickname,
        .detail-answer,
        .detail-time {
          font-family: Inter;
          font-weight: 400;
          font-size: 14px;
          color: #ffffff;
          flex: 1;
          text-align: center;

          &:first-child {
            text-align: left;
          }

          &:last-child {
            text-align: right;
          }
        }
        .detail-nickname {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
}

.quiz-footer {
  padding: 0 24px 16px;
  display: flex;
  gap: 8px;

  .action-btn {
    flex: 1;
    height: 40px;
    border-radius: 12px;
    font-family: PingFang SC;
    font-weight: 500;
    font-size: 14px;
    transition: all 0.3s;

    &.end-btn {
      color: #f53f3f !important;
    }

    &.el-button--default {
      background: rgba(63, 63, 70, 0.4);
      border-color: transparent;
      color: #ecedee;

      &:hover {
        background: rgba(63, 63, 70, 0.6);
        border-color: transparent;
        color: #ffffff;
      }

      &:active {
        background: rgba(63, 63, 70, 0.8);
      }
    }

    &.el-button--primary {
      background: #0e42d2;
      border-color: transparent;
      color: #ffffff;

      &:hover {
        background: #165dff !important;
        border-color: transparent !important;
        color: #ffffff;
      }

      &:active {
        background: #0a35a8;
      }
    }
    &.is-disabled {
      opacity: 1 !important;
      background: #1e1e20;
      background-color: #1e1e20 !important;
      border-color: #1e1e20 !important;
      color: #e8f3ff !important;
      &.btn-highlight {
        color: #4080ff !important;
      }
      &:hover {
        background: rgba(63, 63, 70, 0.4) !important;
      }
    }
  }
}
::v-deep .fill-input {
  .el-input__inner {
    color: #86909c;
    background: rgba(18, 18, 18, 0.3);
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
    border-radius: 12px 12px 12px 12px;
    border: 1px solid #4e5969;
  }
  .el-input__count-inner {
    color: #86909c;
    background: rgba(18, 18, 18, 0.3);
  }
}
</style>
<style lang="scss">
.end-quiz-confirm {
  width: 327px;
  background: #18181b;
  box-shadow: 0px 8px 60px 2px rgba(0, 0, 0, 0.8);
  border-radius: 12px 12px 12px 12px;
  border: 2px solid #27272a;

  .el-message-box__container {
    position: unset;
    display: flex;
    height: 40px;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-top: -15px;
  }

  .el-message-box__status {
    position: unset;
    transform: unset;
    margin-right: 4px;
  }
  .el-message-box__message {
    font-weight: 400;
    font-size: 14px;
    color: #f7f8fa;
    line-height: 20px;
    padding: 0;
  }
  .el-button {
    width: 140px;
    font-weight: 500;
    font-size: 14px;
    padding: 10px 0;
    color: #e8f3ff;
    border: none;
    border-radius: 12px 12px 12px 12px;
    background: rgba(63, 63, 70, 0.4);
    &.el-button--primary {
      background: #0e42d2;
    }
    &:hover,
    &:focus {
      border: none;
      color: #e8f3ff;
      background: #0e42d2 !important;
    }
  }
}
.option-detail-popover {
  background: #18181b;
  border-radius: 12px;
  border: 2px solid #27272a;
  padding: 12px;

  // 自定义滚动条样式
  ::-webkit-scrollbar {
    width: 4px;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background: #252527;
    border-radius: 2px;

    &:hover {
      background: #252527;
    }
  }

  ::-webkit-scrollbar-corner {
    background: transparent;
  }

  .popper__arrow {
    border-top-color: #18181b !important;
    &::after {
      border-top-color: #18181b !important;
    }
  }
  .option-detail {
    .option-detail-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 8px;
      color: #86909c !important;
    }
    .option-detail-item-wrap {
      max-height: 128px;
      overflow: scroll;
    }
    .option-detail-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
      line-height: 28px;
      padding: 0;

      .nickname {
        max-width: 69px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}
</style>
